module.exports = __webpack_public_path__ + "img/coupon3.5cf62645.png";